// src/forms/Login.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './login.css';
import translations from '../lang';

import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';

export default function Login() {
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language];

  const [consentGiven, setConsentGiven] = useState(false);

  // ✅ ÚJ: user_type választó mindig látszik
  const [userType, setUserType] = useState('client'); // alapértelmezett: client

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('inactive') === '1') {
      alert(t.inactive_account || 'Your account is not active yet.');
    }
  }, [t.inactive_account]);

  const handleGoogleContinue = async () => {
    if (!consentGiven) {
      alert(t.must_accept_privacy || 'You must accept the privacy policy.');
      return;
    }

    const apiBase = process.env.REACT_APP_API;
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

    // ✅ HELYES natív detektálás
    const isNative =
      typeof Capacitor.isNativePlatform === 'function'
        ? Capacitor.isNativePlatform()
        : Capacitor.getPlatform() !== 'web';

    console.log('[LOGIN] isNative:', isNative, 'platform:', Capacitor.getPlatform());
    console.log('[LOGIN] apiBase:', apiBase);
    console.log('[LOGIN] googleClientId exists:', !!googleClientId);
    console.log('[LOGIN] selected userType:', userType);

    // 1) WEB: redirect flow
    if (!isNative) {
      // ✅ user_type átadása query paramként
      const params = new URLSearchParams({ user_type: userType });
      window.location.href = `${apiBase}/api/auth/google/start/?${params.toString()}`;
      return;
    }

    // 2) NATÍV (android/ios): SocialLogin plugin -> id_token -> POST a backendnek
    try {
      if (!googleClientId) {
        alert('Missing REACT_APP_GOOGLE_CLIENT_ID (check .env formatting!)');
        return;
      }

      await SocialLogin.initialize({
        google: {
          webClientId: googleClientId,
          mode: 'online',
        },
      });

      const response = await SocialLogin.login({
        provider: 'google',
        options: {},
      });

      if (response.provider !== 'google') {
        alert('Google login failed: wrong provider');
        return;
      }

      const result = response.result || {};
      const idToken = result.idToken || result.id_token;

      if (!idToken) {
        console.log('Full SocialLogin response:', response);
        alert('Google login failed: no idToken. Nézd meg a konzolt a részletekhez.');
        return;
      }

      const res = await fetch(`${apiBase}/api/auth/google/mobile/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': language,
        },
        body: JSON.stringify({
          id_token: idToken,
          platform: Capacitor.getPlatform(),
          user_type: userType, // ✅ elküldjük a választást
        }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.log('Backend mobile login error:', errData);
        alert(
          errData.detail ||
            errData.error ||
            errData.message ||
            JSON.stringify(errData) ||
            'Google mobil bejelentkezés sikertelen.'
        );
        return;
      }

      const data = await res.json();

      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      localStorage.setItem('username', data.username || data.email || '');
      localStorage.setItem('user_type', data.user_type || userType || 'client');
      localStorage.setItem('isLoggedIn', 'true');

      window.location.href = '/';
    } catch (err) {
      console.error('Google SocialLogin error:', err);
      alert('Google bejelentkezés közben hiba történt.');
    }
  };

  const goToPrivacy = () => {
    navigate('/privacy', {
      state: { from: location.pathname || '/login' },
    });
  };

  return (
    <div className="containerLogin">
      <h2>{t.login}</h2>

      <div className="privacy-consent">
        <input
          type="checkbox"
          checked={consentGiven}
          onChange={(e) => setConsentGiven(e.target.checked)}
          id="login-consent"
        />
        <label htmlFor="login-consent">
          {t.consent_prefix}{' '}
          <button type="button" className="privacy-link" onClick={goToPrivacy}>
            {t.privacy_policy}
          </button>{' '}
          {t.consent_suffix}
        </label>
      </div>

      {/* ✅ ÚJ: user_type választó mindig ott van a Google gomb felett */}
      <label style={{ display: 'block', marginTop: 12 }}>
        {t.user_type || 'User type'}:
        <select
          value={userType}
          onChange={(e) => setUserType(e.target.value)}
          style={{ width: '100%', marginTop: 6 }}
        >
          <option value="client">{t.client || 'Időpont foglaló'}</option>
          <option value="provider">{t.provider || 'Szolgáltató'}</option>
        </select>
      </label>

      <button
        type="button"
        className="google-btn primary-btn"
        onClick={handleGoogleContinue}
        disabled={!consentGiven}
        title={!consentGiven ? (t.must_accept_privacy || 'You must accept the privacy policy.') : ''}
        style={{ marginTop: 14 }}
      >
        {t.continue_with_google || 'Continue with Google'}
      </button>
    </div>
  );
}
